;(function () {
  angular
    .module('contrast.form')
    .directive(
      'autoSubmitForm',
      function autoSubmitForm(
        $timeout,
        $cookies,
        CONTRAST_CSRF_TOKEN,
        CONTRAST_CSRF_COOKIE
      ) {
        'ngInject'

        return {
          replace: true,
          scope: {
            targetWindow: '@'
          },
          template:
            '<form action="{{formData.redirectUrl}}" method="{{formData.redirectMethod}}" target="{{targetWindow}}">' +
            '<div ng-repeat="item in formData.redirectData">' +
            '<input type="hidden" name="{{item.name}}" value="{{item.value}}" />' +
            '</div>' +
            '</form>',
          link: function ($scope, element, $attrs) {
            if (!$scope.targetWindow) {
              $scope.targetWindow = '_self'
            }
            $scope.$on($attrs['event'], function (event, data) {
              $scope.formData = data
              if (angular.isUndefined($scope.formData.redirectData)) {
                $scope.formData.redirectData = []
              }
              //add csrf token
              $scope.formData.redirectData.push({
                name: CONTRAST_CSRF_TOKEN,
                value: $cookies.get(CONTRAST_CSRF_COOKIE)
              })

              $timeout(function () {
                element.submit()
              })
            })
          }
        }
      }
    )
})()
